import { IconClock } from '@tabler/icons-react';

interface InvoiceStatusBadgeProps {
}

import { Invoice } from '@next-is-free-monorepo/next-is-free-types';
import { Button, Tooltip } from 'antd';

const InvoiceStatusBadge = ({ invoice }: { invoice: Invoice }) => {

  if (invoice.status === 'paid') {
    return (
      <div className={'bg-green-100 text-green-700 px-2 py-0.5 rounded'}>
        Pagata
      </div>
    );
  }

  if (invoice.status === 'uncollectible') {
    return (
      <div className={'bg-slate-100 text-slate-700 px-2 py-0.5 rounded'}>
        Annullata
      </div>
    );
  }

  if (invoice.status === 'open') {

    if (invoice.payment_intent?.status === 'processing') {
      return (
        <Tooltip title={'La banca sta processando il pagamento, questo potrebbe richiedere alcuni giorni.'}>
          <div className={'bg-slate-100 text-slate-700 px-2 py-0.5 rounded flex items-center gap-1'}>
            <IconClock size={12} /> In sospeso
          </div>
        </Tooltip>
      );
    } else {
      return (
        <div className={'flex gap-2'}>
          <div className={'bg-red-100 text-red-500 px-2 py-0.5 rounded flex items-center gap-1'}>
            Da pagare
          </div>
          <div className={'bg-black text-white px-2 py-0.5 rounded flex items-center gap-1'}>Paga ora</div>
        </div>
      );
    }
  } else {
    return (<div className={'bg-slate-100 text-slate-700 px-2 py-0.5 rounded'}>
      Annullata
    </div>);
  }

};
export default InvoiceStatusBadge;
